import { render, staticRenderFns } from "./fbAndAf.vue?vue&type=template&id=e9c6603e&scoped=true"
import script from "./fbAndAf.vue?vue&type=script&lang=js"
export * from "./fbAndAf.vue?vue&type=script&lang=js"
import style0 from "./fbAndAf.vue?vue&type=style&index=0&id=e9c6603e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c6603e",
  null
  
)

export default component.exports